/** Fields the contracts API can sort by, as sent to the API. */
export const CONTRACT_SORT_FIELDS = [
  'modified_on',
  'created_on',
  'contract_date',
  'valid_from',
  'valid_until',
] as const;
